import { render, staticRenderFns } from "./Sicherheitsdatenblaetter.vue?vue&type=template&id=8681430a"
import script from "./Sicherheitsdatenblaetter.vue?vue&type=script&lang=js"
export * from "./Sicherheitsdatenblaetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports